import React, { useState, useEffect } from 'react'
import { UploadDoc } from './UploadDoc'
import { MapDoc } from './Map'
import { Flex } from '../../Components/Common/Flex'
import { useParams, useNavigate } from 'react-router-dom'
import { FC, invalidateQuery } from '../../Services'

export const MapDocument = () => {
  const { mappedDocumentId, environmentId } = useParams()
  const navigate = useNavigate()
  const [step, setStep] = useState(0)
  const [pageNumber, setPageNumber] = useState(1)
  const [name, setName] = useState('')
  const [doc, setDoc] = useState({ documentUrl: '', id: '' })
  const [labelElements, setLabelElements] = useState([])
  const [conditionalElements, setConditionalElements] = useState([])
  const [imageElements, setImageElements] = useState([])
  const [dateElements, setDateElements] = useState([])

  const save = async () => {
    if (!mappedDocumentId) {
      // is new
      const { id } = await FC.service('mappedDocuments').create({ documentId: doc.id, elements: { labelElements, conditionalElements, imageElements, dateElements }, environmentId, name })
      navigate('/environments/' + environmentId + '/mapDocument/' + id)
      invalidateQuery(['mappedDocuments'])
      window.growl.show({ severity: 'success', summary: 'Success', detail: 'Documento salvato' })
      return
    }
    await FC.service('mappedDocuments').patch(mappedDocumentId, { elements: { labelElements, conditionalElements, imageElements, dateElements }, documentId: doc.id })
    window.growl.show({ severity: 'success', summary: 'Success', detail: 'Documento salvato' })
  }

  useEffect(() => {
    if (mappedDocumentId) {
      // is edit
      FC.service('mappedDocuments').find({ query: { id: mappedDocumentId } }).then(([res]) => {
        setLabelElements(res?.elements?.labelElements || [])
        setConditionalElements(res?.elements?.conditionalElements || [])
        setImageElements(res?.elements?.imageElements || [])
        setDateElements(res?.elements?.dateElements || [])
        setDoc({ documentUrl: res?.document?.uri, id: res?.document?.id })
        setStep(1)
      })
    }
  }, [mappedDocumentId])

  return (
    <Flex fw>
      {step === 0 && <UploadDoc onUpload={(doc) => { setDoc(doc); setStep(1) }} name={[name, setName]} />}
      {step === 1 && <MapDoc
        doc={doc}
        pageNumber={[pageNumber, setPageNumber]}
        save={save}
        labelElements={[labelElements, setLabelElements]}
        conditionalElements={[conditionalElements, setConditionalElements]}
        imageElements={[imageElements, setImageElements]}
        dateElements={[dateElements, setDateElements]}
                     />}
    </Flex>
  )
}
